module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 23
// module chunks = 0